import { render, staticRenderFns } from "./BaseSelectModalBox.vue?vue&type=template&id=54f75fd0&scoped=true"
import script from "./BaseSelectModalBox.vue?vue&type=script&lang=js"
export * from "./BaseSelectModalBox.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectModalBox.vue?vue&type=style&index=0&id=54f75fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f75fd0",
  null
  
)

export default component.exports